<template>
    <div id="cart-products">
        <div
            v-if="$scope.IS_SALES_REP && cart && cart.customer"
            class="frame-outline mb text-yanone text-uppercase"
        >
            <p class="mx-0 my-0">
                <i class="icon-cr icon-indicates new-up-icons" />
                Você está comprando para:
                <strong class="text-info-3">
                    {{ cart.customer.data.full_name }}
                </strong>
            </p>
        </div>

        <div v-if="$scope.IS_SALES_REP && cart" class="frame-outline mb text-yanone text-uppercase">
            <p class="mx-0 my-0">
                <i class="icon-cr icon-carrier-car" />
                <span>
                    Previsão de envio:
                    <strong v-if="cart.fixed_shipping_days" class="text-info-3">
                        {{ $f.formatDate(cart.fixed_shipping_date, 'DD/MM/YY') }}.
                    </strong>
                    <strong v-else class="text-info-3"> Automática. </strong>
                    <a
                        class="text-primary cursor-pointer"
                        @click="$emit('request-shipping-days-modal')"
                    >
                        Clique aqui para alterar.
                    </a>
                </span>
            </p>
        </div>

        <template v-show="!loading">
            <template v-if="!noStockAlert && false">
                <slot
                    name="cart-fast-delivery"
                    :products="products"
                    :fast-delivery="fastDelivery"
                />
            </template>

            <Alert :alert="productsAlert" />
            <Alert :alert="noStockAlert" />

            <div class="frame-outline px-0 pt-1" v-for="storesBag in storesBags">
                <div v-if="$scope.TENANT_IDENTIFIER !== 'chicorei'">
                    <div v-if="storesBag.store.name !== 'Uma Penca'">
                        <h4 class="section-title mt-0" v-if="showBagName">
                            <i class="icon-cr icon-store new-icon" />
                            <span>&nbsp;{{ storesBag.store.name }}</span>
                        </h4>
                    </div>
                    <div v-else class="d-flex flex-justify-between flex-align-center">
                        <h4 class="section-title mt-0" v-if="showBagName">
                            <i class="icon-cr icon-store new-icon" />
                            <span>&nbsp;{{ storesBag.store.name }}</span>
                        </h4>
                        <a
                            class="btn-personalizados"
                            href="/produtos-personalizados"
                            v-if="
                                !($scope.STORE && $scope.STORE.id) &&
                                Object.keys(storesBag.customizable_products).length > 0
                            "
                        >
                            Crie mais produtos personalizados
                        </a>
                    </div>
                </div>

                <ul class="cart-products-list" style="list-style-type: none">
                    <CartGiftOffer
                        v-if="
                            cart &&
                            cart.gift_offer &&
                            !isGiftProductInCart &&
                            $scope.tenant_identifier === 'chicorei'
                        "
                        :gift-offer="cart.gift_offer"
                        :is-lateral-menu="isLateralMenu"
                        class="product-list-item"
                        @add-gift="addGiftOffer"
                    />
                    <CartProduct
                        v-for="cartProduct in storesBag.products"
                        :key="`${cartProduct.produto_id}_${cartProduct.variation_id}`"
                        :cart-product="cartProduct"
                        :maximum-allowed-packings="cart.maximum_allowed_packings"
                        :is-lateral-menu="isLateralMenu"
                        :fast-delivery="fastDelivery"
                        class="product-list-item"
                        @remove="remove(cartProduct)"
                        @add-one="addOne(cartProduct)"
                        @remove-one="removeOne(cartProduct)"
                        @quantity-change="onTypeProductQuantity(cartProduct, $event)"
                    />
                    <div class="customizable-options">
                        <div
                            v-for="(customizableProducts, index) in storesBag.customizable_products"
                            :key="index"
                            class="line-bottom"
                        >
                            <div
                                :class="{
                                    [Object.keys(storesBag.customizable_products)[0] == index &&
                                    storesBags[0].products.length === 0
                                        ? 'product-list-item-top-border'
                                        : 'mt-4']: true,
                                }"
                            >
                                <slot
                                    name="customizable-cart-products"
                                    :customizable-products="customizableProducts"
                                    @remove-customizable="removeCustomizable(customizableProducts)"
                                    @update-cart="$emit('update-cart')"
                                />
                            </div>
                        </div>
                    </div>
                </ul>
            </div>
        </template>
    </div>
</template>
<script>
    import { updateLazyLoad } from '../../script/common';
    import { cartStore } from '../../script/store/cart-store';
    import Alert from '../surface/alert/Alert.vue';
    import CartProduct from './CartProduct.vue';
    import CartGiftOffer from './special-promo/CartGiftOffer.vue';

    export default {
        name: 'CartProducts',

        components: {
            CartGiftOffer,
            CartProduct,
            Alert,
        },

        props: ['loading', 'products', 'cart', 'isLateralMenu', 'fastDelivery'],

        data() {
            return {
                productsAlert: null,
                loadingDonations: false,
            };
        },

        mounted() {
            updateLazyLoad();
        },

        watch: {
            products: function () {
                this.$nextTick(function () {
                    updateLazyLoad();
                });
            },
        },

        computed: {
            isGiftProductInCart: function () {
                if (!this.cart || !this.cart.products || !this.cart.gift_offer) return false;

                for (let product of this.cart.products.data) {
                    if (product.produto_id == this.cart.gift_offer.product_id) {
                        return true;
                    }
                }
                return false;
            },

            showBagName() {
                return (
                    this.storesBags.length > 1 ||
                    (this.storesBags.length === 1 &&
                        (!this.$scope.STORE ||
                            this.$scope.STORE.name !== this.storesBags[0].store.name))
                );
            },

            storesBags() {
                if (!this.products) return [];

                const storeBagsKeyed = {};
                const storeBag = [];

                let orderedProducts = this.products.sort((a, b) => {
                    return a.product.is_gift ? -1 : 1;
                });

                orderedProducts.forEach((cartProduct) => {
                    const storeId = (cartProduct.product.store || {}).id || 0;
                    if (!storeBagsKeyed[storeId]) {
                        storeBagsKeyed[storeId] = {
                            products: [],
                            customizable_products: {},
                            store: cartProduct.product.store || { name: 'Uma Penca' },
                        };
                    }

                    if (cartProduct.canvas_id) {
                        if (!storeBagsKeyed[storeId].customizable_products[cartProduct.canvas_id]) {
                            storeBagsKeyed[storeId].customizable_products[cartProduct.canvas_id] =
                                [];
                        }
                        storeBagsKeyed[storeId].customizable_products[cartProduct.canvas_id].push(
                            cartProduct
                        );
                    } else {
                        storeBagsKeyed[storeId].products.push(cartProduct);
                    }
                });

                for (let index in storeBagsKeyed) {
                    storeBag.push(storeBagsKeyed[index]);
                }

                return storeBag.sort((a, b) => a.store.name > b.store.name);
            },

            noStockAlert() {
                if (this.products) {
                    for (let i = 0; i < this.products.length; i++) {
                        if (!this.products[i].has_quantity || !this.products[i].can_be_bought) {
                            return {
                                message:
                                    'Sua sacola possui produtos fora de estoque, para finalizar a compra será necessário removê-lo.',
                                isError: true,
                                timeout: 0,
                            };
                        }
                    }
                }
                return null;
            },
        },

        methods: {
            handleCartApiError: function (response, defaultMessage) {
                try {
                    response = response.response.data;
                    let message = response.errors[0][0];

                    for (let i = 1; i < response.errors.length; i++) {
                        message += ';' + response.errors[i][0];
                        if (i === response.errors.length - 1) {
                            message += '.';
                        }
                    }

                    this.productsAlert = {
                        message: message,
                        isError: true,
                    };
                } catch (error) {
                    this.productsAlert = {
                        message: defaultMessage,
                        isError: true,
                    };
                }
            },

            addOne: function (product) {
                if (
                    product.product.type.id !== 13 ||
                    product.quantity < this.cart.maximum_allowed_packings
                ) {
                    this.updateProductQuantity(product, product.quantity + 1);
                }
            },

            removeOne: function (product) {
                this.updateProductQuantity(product, product.quantity - 1);
            },

            removeCustomizable: function (products) {
                for (let key in products) {
                    if (products.hasOwnProperty(key)) {
                        this.remove(products[key]);
                    }
                }
            },

            remove: function (product) {
                this.updateProductQuantity(product, 0);
            },

            onTypeProductQuantity: function (product, ev) {
                const typedQuantity = parseInt(ev.target.value);
                const quantity =
                    product.product.type.id === 13
                        ? Math.min(typedQuantity, this.cart.maximum_allowed_packings)
                        : typedQuantity;
                if (quantity !== product.quantity) {
                    this.updateProductQuantity(product, quantity);
                } else {
                    ev.target.value = quantity;
                }
            },

            addGiftOffer: function () {
                this.$emit('changing-products');
                cartStore
                    .updateProduct({
                        products: [
                            {
                                product_id: this.cart.gift_offer.product_id,
                                variation_id: this.cart.gift_offer.cart_product.variation_id,
                                quantity: 1,
                            },
                        ],
                    })
                    .then(() => {
                        this.productsAlert = {
                            message: 'Item adicionado com sucesso :)',
                        };
                        this.$emit('update-cart');
                    })
                    .catch(() => {
                        this.productsAlert = {
                            message: 'Não foi possível adicionar o item. Tente novamente.',
                            isError: true,
                        };
                        this.$emit('done-changing-products');
                    });
            },

            updateProductQuantity: function (product, requestedQuantity) {
                this.$emit('changing-products');

                const diffQuantity = requestedQuantity - product.quantity;

                cartStore
                    .updateProduct({
                        products: [
                            {
                                product_id: product.produto_id,
                                variation_id: product.variation_id,
                                quantity: diffQuantity,
                            },
                        ],
                    })
                    .then(() => {
                        if (requestedQuantity === 0) {
                            this.productsAlert = {
                                message: 'Item removido com sucesso',
                            };
                        }

                        this.$emit('update-cart');
                        this.$emit('product-quantity-changed', product, diffQuantity);
                    })
                    .catch((response) => {
                        this.$emit('done-changing-products');
                        this.handleCartApiError(
                            response,
                            requestedQuantity === 0
                                ? 'Não foi possível remover o item'
                                : 'Não foi possível alterar a quantidade'
                        );
                    });
            },
        },
    };
</script>
